import { useState, useRef } from 'react'
import { styled, theme } from 'twin.macro'
import TitleInput from './title-input'
import ContentInput from './content-input'
import Label from '../_shared/Label'
import TextInputLightbox from './TextInputLightbox'
import { useArticleContext } from '../_core'

const Container = styled.div`
  padding: 20px 16px;
  #title,
  #editor {
    pointer-events: none;
  }

  .codex-editor__redactor {
    padding-bottom: 0 !important;
  }

  @media (min-width: ${theme`screens.md`}) {
    margin-top: 32px;
    padding: 0;
    #title,
    #editor {
      pointer-events: auto;
    }

    .codex-editor__redactor {
      padding-bottom: 300px !important;
    }
  }

  @media (max-width: ${theme`screens.md`}) {
    #editor {
      max-height: 102px;
      overflow-y: hidden;
    }
  }
`

const TitleContentInput = () => {
  const ref = useRef<HTMLDivElement>()
  const [isLightboxVisible, setIsLightboxVisible] = useState(false)
  const { clearTitleContentRequiredWarnings } = useArticleContext()

  const openLightbox = () => setIsLightboxVisible(true)
  const closeLightbox = () => setIsLightboxVisible(false)

  const onClick = (e) => {
    if (e.target !== e.currentTarget) return
    if (window.matchMedia(`(min-width: ${theme`screens.md`})`).matches) return
    clearTitleContentRequiredWarnings()
    openLightbox()
  }

  return (
    <>
      <Container tw="space-y-4" onClick={onClick} ref={ref}>
        <Label tw="md:hidden" $required>
          文章內容
        </Label>
        <TitleInput />
        <ContentInput />
      </Container>
      {isLightboxVisible && <TextInputLightbox close={closeLightbox} containerRef={ref} />}
    </>
  )
}

export default TitleContentInput
